import { Reveal } from './Reveal';

/**
 * The heading a page opens with.
 *
 * The same eyebrow/title/standfirst pairing the sections use, so a page head
 * and a section head are recognisably the same object at two different sizes —
 * what separates them is the `<h1>` and the room to clear the fixed bar.
 *
 * Only the pages that do not already open with a heading of their own take
 * one. `/our-story` opens on the story's own head and would only be repeating
 * itself.
 */
export function PageHead({
  eyebrow,
  title,
  lead,
}: {
  eyebrow: string;
  title: string;
  lead?: string;
}) {
  return (
    <section class="section pagehead">
      <div class="shell shell--reading">
        <div class="intro">
          <Reveal class="section-head">
            <span class="eyebrow">{eyebrow}</span>
            <h1>{title}</h1>
          </Reveal>
          {lead && (
            <Reveal class="prose" delay={60}>
              <p>{lead}</p>
            </Reveal>
          )}
        </div>
      </div>
    </section>
  );
}
